import { extraccionSimple } from "./dbhelper"

export const obtenerDepartamentos = (params) => {
    return extraccionSimple("departamentos");
}
